import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrdemServicoService {
  private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getFormulariosManutencao() {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/formulariomanutencao')
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
  }
  
  getFormularioManutencao(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/formulariomanutencao/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  criaFormularioManutencao(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/formulariomanutencao', {
				formulario_manutencao_relato_socorrista: data.formulario_manutencao_relato_socorrista,
				formulario_manutencao_relato_mecanico: data.formulario_manutencao_relato_mecanico,
				formulario_manutencao_mecanico_receptor: data.formulario_manutencao_mecanico_receptor,
				veiculo_id: data.veiculo_id,
				formulario_manutencao_condutor_receptor: data.formulario_manutencao_condutor_receptor,
				formulario_manutencao_mecanico_data: data.formulario_manutencao_mecanico_data,
				formulario_manutencao_socorrista_data: data.formulario_manutencao_socorrista_data,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaFormularioManutencao(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/formulariomanutencao/' + data.formulario_manutencao_id, {
				formulario_manutencao_relato_socorrista: data.formulario_manutencao_relato_socorrista,
				formulario_manutencao_relato_mecanico: data.formulario_manutencao_relato_mecanico,
				formulario_manutencao_mecanico_receptor: data.formulario_manutencao_mecanico_receptor,
				veiculo_id: data.veiculo_id,
				formulario_manutencao_condutor_receptor: data.formulario_manutencao_condutor_receptor,
				formulario_manutencao_mecanico_data: data.formulario_manutencao_mecanico_data,
				formulario_manutencao_socorrista_data: data.formulario_manutencao_socorrista_data,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaFormularioManutencao(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/formulariomanutencao/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
